// Where sonner's toasts start from the top of the screen. The <Toaster> in
// App.jsx reads its top offset through this CSS variable, so a sheet pinned to
// the top (the Taunt composer) can move the toasts to just below itself while
// it is open, with no re-render. With the variable unset the toaster uses
// sonner's own offsets: 24px, and 16px on phones (up to 600px wide).
//
// The GM-stale banner and the last-player warning are separate fixed banners,
// not toasts, so they still sit over a top sheet when they show.
export const TOAST_TOP_VAR = '--tasted-toast-top';
export const TOASTER_OFFSET = { top: `var(${TOAST_TOP_VAR}, 24px)` };
export const TOASTER_MOBILE_OFFSET = { top: `var(${TOAST_TOP_VAR}, 16px)` };

// For a sheet fixed at top: 0. Toasts start `gap` px below its bottom edge
// until the returned cleanup runs. Uses the layout height, not
// getBoundingClientRect, so a sheet still sliding in (a transform) is measured
// where it comes to rest; a ResizeObserver keeps up if the sheet's height
// changes (a bigger text size, say).
export function placeToastsBelow(el, gap = 8) {
  if (!el || typeof document === 'undefined') return () => {};
  const root = document.documentElement;
  const update = () => {
    root.style.setProperty(TOAST_TOP_VAR, `${el.offsetHeight + gap}px`);
  };
  update();
  const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(update) : null;
  observer?.observe(el);
  return () => {
    observer?.disconnect();
    root.style.removeProperty(TOAST_TOP_VAR);
  };
}
